import { createStyledContext, getToken, styled, Text, View, withStaticProperties } from "@tamagui/core";
import { StyledIcon } from "../Icon/Icon.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
const CalloutContext = createStyledContext({
    variant: "information"
  }),
  CalloutFrame = styled(View, {
    context: CalloutContext,
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    borderRadius: "$callout.default",
    flexDirection: "column",
    gap: "$callout.gap",
    overflow: "visible",
    padding: "$callout.padding",
    variants: {
      variant: {
        error: {
          backgroundColor: "$callout.error.background"
        },
        information: {
          backgroundColor: "$callout.information.background"
        },
        warning: {
          backgroundColor: "$callout.warning.background"
        }
      }
    }
  }),
  CalloutTitle = styled(Text, {
    context: CalloutContext,
    flexGrow: 0,
    flexShrink: 1,
    fontFamily: "$body",
    fontSize: "$regular",
    fontWeight: "500",
    lineHeight: "$regular",
    name: "CalloutTitle",
    variants: {
      variant: {
        error: {
          color: "$callout.error.text"
        },
        information: {
          color: "$callout.information.text"
        },
        warning: {
          color: "$callout.warning.text"
        }
      }
    }
  }),
  CalloutContent = styled(Text, {
    context: CalloutContext,
    flexGrow: 0,
    flexShrink: 1,
    fontFamily: "$body",
    fontSize: "$small",
    fontWeight: "400",
    lineHeight: "$small",
    name: "CalloutTitle",
    variants: {
      variant: {
        error: {
          color: "$callout.error.text"
        },
        information: {
          color: "$callout.information.text"
        },
        warning: {
          color: "$callout.warning.text"
        }
      }
    }
  }),
  CalloutIconContainer = styled(View, {
    context: CalloutContext,
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    borderColor: "$white",
    borderRadius: "$round",
    borderWidth: 4,
    padding: "$callout.iconContainer.padding",
    position: "absolute",
    right: -16,
    top: -16,
    variants: {
      variant: {
        error: {
          backgroundColor: "$callout.error.background"
        },
        information: {
          backgroundColor: "$callout.information.background"
        },
        warning: {
          backgroundColor: "$callout.warning.background"
        }
      }
    }
  }),
  CalloutStyledIcon = styled(StyledIcon, {
    context: CalloutContext,
    size: "small",
    variants: {
      variant: {
        error: {
          color: "$callout.error.text"
        },
        information: {
          color: "$callout.information.text"
        },
        warning: {
          color: "$callout.warning.text"
        }
      }
    }
  }),
  CalloutActionText = styled(Text, {
    context: CalloutContext,
    flexGrow: 0,
    flexShrink: 1,
    fontFamily: "$body",
    fontSize: "$regular",
    fontWeight: "500",
    lineHeight: "$regular",
    name: "CalloutActionText",
    variants: {
      variant: {
        error: {
          "$group-calloutAction-hover": {
            color: "$callout.error.text.hover"
          },
          "$group-calloutAction-press": {
            color: "$callout.error.text.press"
          },
          color: "$callout.error.text"
        },
        information: {
          "$group-calloutAction-hover": {
            color: "$callout.information.text.hover"
          },
          "$group-calloutAction-press": {
            color: "$callout.information.text.press"
          },
          color: "$callout.information.text"
        },
        warning: {
          "$group-calloutAction-hover": {
            color: "$callout.warning.text.hover"
          },
          "$group-calloutAction-press": {
            color: "$callout.warning.text.press"
          },
          color: "$callout.warning.text"
        }
      }
    }
  }),
  CalloutActionTextBorder = styled(View, {
    bottom: 0,
    context: CalloutContext,
    height: "$button.tertiaryIndicator.height",
    left: 0,
    position: "absolute",
    right: 0,
    variants: {
      variant: {
        error: {
          "$group-calloutAction-hover": {
            backgroundColor: "$callout.error.text.hover"
          },
          "$group-calloutAction-press": {
            backgroundColor: "$callout.error.text.press"
          },
          backgroundColor: "$callout.error.text"
        },
        information: {
          "$group-calloutAction-hover": {
            backgroundColor: "$callout.information.text.hover"
          },
          "$group-calloutAction-press": {
            backgroundColor: "$callout.information.text.press"
          },
          backgroundColor: "$callout.information.text"
        },
        warning: {
          "$group-calloutAction-hover": {
            backgroundColor: "$callout.warning.text.hover"
          },
          "$group-calloutAction-press": {
            backgroundColor: "$callout.warning.text.press"
          },
          backgroundColor: "$callout.warning.text"
        }
      }
    }
  }),
  CalloutActionContainer = styled(View, {
    alignSelf: "flex-start",
    borderRadius: "$link.focusRing.radius",
    cursor: "pointer",
    focusable: !0,
    group: "calloutAction",
    maxWidth: "100%",
    tag: "button",
    width: "auto"
  }),
  CalloutAction = ({
    children,
    onPress
  }) => /* @__PURE__ */jsxs(CalloutActionContainer, {
    focusVisibleStyle: {
      // @ts-expect-error boxShadow is correctly spreaded to the component
      boxShadow: `0 0 0 2px white, 0 0 0 4px ${getToken("$outline", "color")}`,
      outline: 0
    },
    children: [/* @__PURE__ */jsx(CalloutActionText, {
      onPress,
      children
    }), /* @__PURE__ */jsx(CalloutActionTextBorder, {})]
  }),
  CalloutWithContext = withStaticProperties(CalloutFrame, {
    props: CalloutContext.Provider
  });
function Callout({
  children,
  variant = "information",
  withIcon = !0
}) {
  return /* @__PURE__ */jsxs(CalloutWithContext, {
    variant,
    children: [withIcon ? /* @__PURE__ */jsx(CalloutIconContainer, {
      children: /* @__PURE__ */jsx(CalloutStyledIcon, {
        icon: "information"
      })
    }) : null, children]
  });
}
Callout.Title = CalloutTitle;
Callout.Title.displayName = "Callout.Title";
Callout.Content = CalloutContent;
Callout.Content.displayName = "Callout.Content";
Callout.Action = CalloutAction;
Callout.Action.displayName = "Callout.Action";
export { Callout };
//# sourceMappingURL=Callout.mjs.map
